//
import Autocomplete from "./Autocomplete";
import Backdrop from "./Backdrop";
import Button from "./Button";
import Card from "./Card";
import Input from "./Input";
import Paper from "./Paper";
import Table from "./Table";
import Tooltip from "./Tooltip";
import Typography from "./Typography";

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
  return Object.assign(
    Card(theme),
    Table(theme),
    Input(theme),
    Paper(theme),
    Button(theme),
    Tooltip(theme),
    Backdrop(theme),
    Typography(theme),
    Autocomplete(theme),
    {
      MuiTextField: {
        styleOverrides: {
          root: {
            '& input:not([type="textarea"])': {
              height: "40px", // Set height to 40px for all inputs except textareas
              boxSizing: "border-box",
              padding: "0 14px", // Adjust padding to match the height
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            height: "40px", // Apply height for Select inputs
            "& .MuiSelect-select": {
              padding: "0 14px", // Adjust padding for select input
              display: "flex",
              alignItems: "center",
            },
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          inputRoot: {
            height: "40px", // Apply height to Autocomplete inputs
            padding: "0 14px",
            boxSizing: "border-box",
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            width: 20,
            height: 20,
            padding: 2,
            "& .MuiSvgIcon-root": {
              fontSize: 18, // checkbox size
              borderRadius: 6, // curve corners
              border: "1px solid #1976d2", // custom border (set only once)
              backgroundColor: "#fff", // background when unchecked
              overflow: "hidden",
              boxShadow: "none",
              color: "transparent", // tick hidden initially
            },
            "&.Mui-checked .MuiSvgIcon-root": {
              backgroundColor: "#1976d2", // fill color when checked
              color: "#fff", // tick color
              // ⚠️ remove border here
            },
          },
        },
      },
    }
  );
}
